import React from 'react';
import { Link } from 'react-router-dom';
import ITStrategy from '../icons/IT Strategy.svg';
import SystemIntegration from '../icons/system integration and support.svg';
import CyberSecurity from '../icons/Cyber Security.svg';
import SoftwareDevelopment from '../icons/Software Development.svg';
import DataManagement from '../icons/Data Management.svg';
import ITTraining from '../icons/IT Training and Development.svg';
import ITInfrastructure from '../icons/IT Infrastructure Management.svg';

const services = [
  {
    icon: ITStrategy,
    title: 'IT Strategy & Consulting',
    description: 'WhyMe Solutions delivers strategic IT consulting to align your technology with business objectives. We create IT roadmaps, evaluate existing technology, and guide digital transformation initiatives. Our consulting services enhance technology investments and drive operational effectiveness.',
    href: '/it-strategy'
  },
  {
    icon: SystemIntegration,
    title: 'System Integration & Support',
    description: 'Our system integration and support services facilitate smooth connectivity across your IT systems. We handle system integration, provide reliable IT support, and manage network engagement to ensure operational efficiency. Seamless integration and support optimize your IT infrastructure and enhance performance.',
    href: '/system-integration'
  },
  {
    icon: CyberSecurity,
    title: 'Cybersecurity',
    description: 'Our team offers comprehensive cybersecurity solutions to protect your digital assets. We perform in-depth security assessments, provide threat detection and response, and implement advanced data protection and encryption strategies. Our cybersecurity measures defend against emerging threats and safeguard your business data.',
    href: '/cyber-security'
  },
  {
    icon: SoftwareDevelopment,
    title: 'Software Development & Custom Solutions',
    description: 'We provide specialized software development and custom solutions tailored to your business requirements. Our services include bespoke software development, application design, API integration, and both front-end and back-end development. We deliver customized solutions that improve functionality and operational efficiency.',
    href:'/software-development'
  },
  {
    icon: DataManagement,
    title: 'Data Management & Analytics',
    description: 'Here, we excel in data management and analytics to convert your data into valuable insights. We offer data storage and backup, advanced analytics, and database management services. Our data-driven solutions support better decision-making and strategic planning through insightful business intelligence.',
    href:'/data-management'
  },
  {
    icon: ITTraining,
    title: 'IT Training & Development',
    description: 'Our IT training and development services equip your team with essential skills and knowledge. We offer technical training, end-user education, certification preparation, and tailored workshops. Effective training enhances IT expertise and supports organizational development.',
    href:'/it-training'
  },
  {
    icon: ITInfrastructure,
    title: 'IT Infrastructure Management',
    description: 'Our team manages your IT infrastructure to ensure optimal performance of hardware and cloud systems. We oversee hardware management, cloud infrastructure, server and storage solutions, and disaster recovery planning. Our infrastructure management services ensure reliable IT operations and business continuity.',
    href:'/it-infrastructure'
  },
];

const SubServiceSectionIT = () => {

  return (
    <section className="bg-white py-12 px-4">
    <div className="container mx-auto px-4">
      <div className="flex flex-wrap -mx-4">
        {services.map((service, index) => (
          <div
            key={index}
            className="w-full md:w-1/2 lg:w-1/4 mb-8"
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <div className="flex flex-col justify-between items-center text-center bg-white rounded-lg py-12 px-4 transform transition hover:-translate-y-2 hover:shadow-lg border border-[#13689b] mx-2 h-full">
              <div className="flex-grow">
              <img src={service.icon} alt = {service.title} className='mx-auto' />
                <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
                <p className="text-left text-black">{service.description}</p>
              </div>
              <Link to={service.href} className='text-white bg-[#13689b] mt-4 px-3 py-2 rounded-md font-semibold hover:text-[#13689b] hover:bg-white hover:border hover:border-[#13689b]'>Explore Service</Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
  
  );
};

export default SubServiceSectionIT;
